var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.22,
    height: 13.401,
    viewBox: "0 0 15.22 13.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163101",
    "data-name": "Group 163101",
    transform: "translate(0 0.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19665",
    "data-name": "Group 19665",
    transform: "translate(0 2.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20810",
    "data-name": "Path 20810",
    d: "M4.348,28.393a9.012,9.012,0,0,1,15.116,0,.325.325,0,0,1,0,.353,9.012,9.012,0,0,1-15.116,0A.325.325,0,0,1,4.348,28.393Zm.664.176a8.362,8.362,0,0,0,13.789,0,8.362,8.362,0,0,0-13.789,0Z",
    transform: "translate(-4.296 -24.289)",
    fill: "#35363a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20811",
    "data-name": "Path 20811",
    d: "M37.4,34.883A2.515,2.515,0,1,1,34.882,37.4,2.517,2.517,0,0,1,37.4,34.883Zm0,.651A1.865,1.865,0,1,0,39.262,37.4,1.865,1.865,0,0,0,37.4,35.534Z",
    transform: "translate(-29.787 -33.118)",
    fill: "#35363a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1635",
    "data-name": "Line 1635",
    y1: 12.341,
    x2: 11.593,
    transform: "translate(1.601 0)",
    fill: "none",
    stroke: "#35363a",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.f98763e66f7c88f6020679bccd726265.svg";
export { ForwardRef as ReactComponent };